import { FORCE_AUTHENTICATE } from '@accounts/constants';

import { SELECTED_SSO_SLUG_COOKIE } from './cookies';

export const createURLParams = (): URLSearchParams => new URLSearchParams(window?.location?.search);

export const getShouldForceAuthenticate = () =>
    createURLParams().get(FORCE_AUTHENTICATE) === 'true';

export const getSelectedSSOSlug = () =>
    typeof window !== 'undefined' ? createURLParams().get(SELECTED_SSO_SLUG_COOKIE) : null;

export const getTruncatedUrl = (
    url: string,
    { maxLength, truncateAt }: { maxLength: number; truncateAt: number } = {
        maxLength: 43,
        truncateAt: 37
    }
) => {
    if (!url?.length) {
        return '';
    }
    if (url.length <= maxLength) {
        return url;
    }
    const start = url.substr(0, truncateAt);
    const end = url.substr(url.length - (maxLength - truncateAt), url.length);
    return `${start}...${end}`;
};

const validURLRegex = /^(https?:\/\/)(www\.)?([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,})([:0-9]{3,})?(\/.*)?$/;
const optionalURLRegex =
    /^(https?:\/\/)?(www\.)?([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,})([:0-9]{3,})?(\/.*)?$/;

export const isValidUrl = (url: string, protocolOptional: boolean = false) => {
    const re = protocolOptional ? optionalURLRegex : validURLRegex;

    return re.test(String(url));
};

export const createMarkdownLink = (url: string, text?: string) => `[${text || url}](${url})`;
